import { useHistory } from "react-router-dom";
import { checkIfHasAccessToRoute } from "../routes/util";
import { useContext } from "react";
import { AppContext } from "../context/app";

// use this until we upgrade to react-router v6
export function useNavigate() {
  const { user } = useContext(AppContext);
  const history = useHistory();

  return (route: string) => {
    const userCanAccessRoute = checkIfHasAccessToRoute(user, route);
    if (!userCanAccessRoute) {
      return;
    }
    history.push(route);
  };
}
